import { DefaultService } from '../generated-api';
import { ClaimedPlayer } from '../generated-api';

export const getClaimedPlayers = async (): Promise<ClaimedPlayer[]> => {
  return DefaultService.getClaimedPlayersAdminPlayersClaimedGet();
};

export const unclaimPlayer = async (playerId: string): Promise<any> => {
  return DefaultService.unclaimPlayerProfileAdminPlayersPlayerIdUnclaimDelete({ playerId });
};







